import React from 'react';
import Note from './Note';
import axios from 'axios';
import { Alert, Form, DatePicker, Row, Col, Input } from 'antd';

import apiPath from 'apiPath';
import formItemLayout from 'components/Portal/formItemLayout';
import withSpin from 'components/withSpin';
import moment from 'components/momentWithZone';

class ApplicationStatus extends React.Component {

    state = {
        applicationList: []
    }

    getApplicationStatus = () => {
        axios.get(apiPath + '/admissions/getApplicationStatus', { withCredentials: true }).then(result => {
            this.setState({ applicationList: result.data })
        })
    }

    componentDidMount () {
        this.getApplicationStatus();
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        const { TextArea } = Input;

        return (
            <div>
                {this.props.isWaitList &&
                    <div style={{paddingBottom:'15px'}}><Alert showIcon type="info"
                        message="Notice"
                        description="This applicant is in a Waitlist Status." /></div>
                }

                <Form>
                    {this.state.applicationList.map(app => (
                        <Row key={app.pos} type="flex" justify="start">
                        <Col span={6}>
                                Status: <Input key={app.tType}  defaultValue={app.tType}/>
                            </Col>
                            <Col span={6} style={{marginLeft: '20pt', marginBottom: '10pt'}}>
                                Date: <Input key={moment(app.statusDate).format('YYYY-MM-DD')}  defaultValue={moment(app.statusDate).format('YYYY-MM-DD')}/>
                            </Col>
                        </Row>
                    ))}
                </Form>
            </div>
        );
    }
}

export default withSpin(Form.create()(ApplicationStatus));


// WEBPACK FOOTER //
// ./portal-components/Portal/Admissions/ApplicationStatus.jsx